import { Heart } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useWishlist } from '@/contexts/WishlistContext';
import { useShopifyWishlist } from '@/contexts/ShopifyWishlistContext';
import { cn } from '@/lib/utils';

interface WishlistBadgeProps {
  className?: string;
  iconClassName?: string;
  showBadge?: boolean;
}

export const WishlistBadge = ({ className, iconClassName, showBadge = true }: WishlistBadgeProps) => {
  const { wishlistCount } = useWishlist();
  const { wishlistCount: shopifyWishlistCount } = useShopifyWishlist();
  const totalCount = wishlistCount + shopifyWishlistCount;

  return (
    <Link
      to="/wishlist"
      data-wishlist-target
      aria-label={`Wishlist${totalCount > 0 ? ` (${totalCount} items)` : ''}`}
      className={cn(
        "relative flex items-center justify-center w-8 h-8 rounded-full border border-border text-foreground hover:border-primary hover:text-primary transition-colors",
        className
      )}
    >
      <Heart className={cn("w-4 h-4", iconClassName)} />
      {showBadge && totalCount > 0 && (
        <span className="absolute -top-1.5 -right-1.5 flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[10px] font-semibold bg-primary text-primary-foreground rounded-full animate-scale-in">
          {totalCount > 99 ? '99+' : totalCount}
        </span>
      )}
    </Link>
  );
};
